import type { SiteContent } from '../content/types';
import { Container } from '../components/layout/container';
import { PageHero } from '../components/sections/page-hero';
import { Badge } from '../components/ui/badge';
import { Card, CardContent } from '../components/ui/card';

interface PlaceholderPageProps {
  content: SiteContent;
  type: 'karriere' | 'downloads' | 'legal';
}

export function PlaceholderPage({ content, type }: PlaceholderPageProps): JSX.Element {
  const page = content.placeholderPages[type];

  return (
    <>
      <PageHero title={page.title} text={page.text} />
      <section className="pb-12 sm:pb-16">
        <Container>
          <Card className="bg-white">
            <CardContent className="flex flex-col gap-4 p-6">
              <p className="text-sm leading-relaxed text-[color:var(--color-muted)]">{page.text}</p>
              <Badge className="w-fit">{page.sourceStatus}</Badge>
            </CardContent>
          </Card>
        </Container>
      </section>
    </>
  );
}
